export default __webpack_public_path__ + "static/media/DwijendraTripathi.5a5714fa.jpg";